<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
  },
  watch: {
    // userinfo: {
    //   deep: true,
    //   handler (val) {
    //     console.log(val.menuList)
    //   }
    // }
  }
}
</script>

<style>
  @import "./assets/css/main.css";
  @import "assets/css/colorDark.css";     /*深色主题*/

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  width: 100%;
  height: 100%;
  /*margin-top: 60px;*/
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
body .el-table th.gutter{
  display: table-cell !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue